import React, { useState } from "react";
import * as api from "./api";
import { Button, TextField, Container, Box } from "@material-ui/core";
import { Form, Modal } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";

const ContactUsForm = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    email: "",
    message: "",
  });
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [errors, setErrors] = useState({
    first_name: false,
    email: false,
    message: false,
  });
  const handleCloseModal = () => {
    setIsEmailSent(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleSubmit = () => {
    if (!formData.first_name || !formData.email || !formData.message) {
      setErrors({
        first_name: !formData.first_name,
        email: !formData.email,
        message: !formData.message,
      });
      return;
    }

    if (!validateEmail(formData.email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: true,
      }));
      return;
    }
    api
      .apiPostContactUs(formData.first_name, formData.email, formData.message)
      .then((result) => {
        if (result?.data?.status === "Success") {
          setIsEmailSent(true);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };
  return (
  <>
    <Container maxWidth="sm" className="contactFormContainer">
      <Box className="columnText columnTextContact">
        Contact
        <span style={{ color: "#E00000" }}> Us</span>
      </Box>
      <Form>
        <Box className="textInput">
          <TextField
            placeholder="Full Name"
            variant="standard"
            InputProps={{
              disableUnderline: true,
            }}
            fullWidth
            margin="dense"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            error={errors.first_name}
          />
          <Box className="error-msg">
            {errors.first_name && "First Name is required"}
          </Box>
        </Box>
        <Box className="textInput">
          <TextField
            placeholder="Email"
            variant="standard"
            fullWidth
            margin="dense"
            type="email"
            name="email"
            InputProps={{
              disableUnderline: true,
            }}
            value={formData.email}
            onChange={handleChange}
            error={errors.email} // Apply error styling if error exists
          />
          <Box className="error-msg">
            {errors.email && "Invalid email format"}
          </Box>
        </Box>

       <Box className="textInput">
        <TextField
          placeholder="Message"
          variant="standard"
          fullWidth
          multiline
          rows={5}
          margin="dense"
          InputProps={{
            disableUnderline: true,
          }}
          name="message"
          value={formData.message}
          onChange={handleChange}
          error={errors.message}
          // helperText={errors.message && "Message is required"}
        />
          <Box className="error-msg">
            {errors.message && "Message is required"}
          </Box>
          </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit}
          style={{
            backgroundColor: "#e00000",
            width: "200px",
            backgroundImage: "none",
          }}
        >
          Submit
        </Button>
      </Form>
    </Container>
    <Modal show={isEmailSent} onHide={handleCloseModal}>
      <Modal.Header className="bg-danger text-white">
        <Modal.Title>
          {" "}
          <span
            className="modal-title"
            style={{
              color: "white",
              height: "30px",
              fontWeight: "700",
              fontFamily: "Segoe UI",
              fontSize: "16px",
              background: "#e00000 !important",
            }}
          >
            {" "}
            Message{" "}
          </span>
        </Modal.Title>
        <CancelIcon
          onClick={handleCloseModal}
          style={{ color: "white", cursor: "pointer", outline: "none" }}
        />
      </Modal.Header>
      <Modal.Body>
        <p>Email Sent Successfully!</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleCloseModal}>
          OK
        </Button>
      </Modal.Footer>
      </Modal>
      </>
  );
};

export default ContactUsForm;
